import { pathQueryValueToArray } from "@/helpers/router-helper";

export const selectListGenerator = (
  list: string[],
  labelMapping?: { [key: string]: string }
) => {
  return list.map(v => {
    const label = labelMapping ? labelMapping[v] : v;
    return {
      value: v,
      label: label
    };
  });
};

// クエリパラメータから検索オプションを復元する
export const correctIdArrayParams = (
  value: string | (string | null)[],
  selectableIds: number[] | undefined
) => {
  if (!selectableIds) {
    return [];
  }

  const correctArray = pathQueryValueToArray<string>(value);
  if (!correctArray) {
    return [];
  }

  return correctArray
    .map(v => Number(v))
    .filter(v => selectableIds.includes(v));
};

type SponsoredEventEntryApplicantFilterName =
  | "event_ids"
  | "universities"
  | "graduateYears"
  | "grades"
  | "schedules"
  | "entryDate";

type SponsoredEventEntryApplicantFilterType =
  | "checkbox"
  | "multiSelectbox"
  | "dateRange";

interface SponsoredEventEntryApplicantFilterCondition {
  label: string;
  checkbox_label?: string;
  name: SponsoredEventEntryApplicantFilterName;
  type: SponsoredEventEntryApplicantFilterType;
}

export const ListFilterConditions: SponsoredEventEntryApplicantFilterCondition[] = [
  {
    label: "大学",
    name: "universities",
    type: "multiSelectbox"
  },
  {
    label: "卒年",
    name: "graduateYears",
    type: "multiSelectbox"
  },
  {
    label: "学年",
    name: "grades",
    type: "multiSelectbox"
  },
  {
    label: "申込日時",
    name: "entryDate",
    type: "dateRange"
  },
  {
    label: "イベント",
    name: "event_ids",
    type: "multiSelectbox"
  },
  {
    label: "申込スケジュール",
    name: "schedules",
    type: "multiSelectbox"
  }
];

export const AvailableCsvColumns = [
  { name: "created_at", label: "応募日時" },
  { name: "unique_id", label: "識別コード" },
  { name: "name", label: "名前" },
  { name: "name_kana", label: "名前（カナ）" },
  { name: "university_name", label: "大学" },
  { name: "department_name", label: "学部" },
  { name: "email", label: "大学メールアドレス" },
  { name: "internship_results", label: "インターン実績" },
  { name: "high_school", label: "出身高校名" },
  { name: "activities", label: "学生時代の活動実績" },
  { name: "tel", label: "電話番号" },
  { name: "unofficial_offer_results", label: "内定実績" },
  { name: "full_address", label: "住所" },
  { name: "date_of_birth", label: "生年月日" },
  { name: "grade", label: "学年" },
  { name: "graduate_year", label: "卒業年度" },
  { name: "concentration_name", label: "学科" },
  { name: "seminar_circle", label: "ゼミ・研究室" },
  { name: "course", label: "文理" },
  { name: "schedule", label: "イベント日程" },
  { name: "event_entry_state", label: "参加ステータス" },
  { name: "languages", label: "言語レベル" },
  { name: "self_promotion", label: "自己PR" },
  { name: "student_endeavor", label: "学生時代に頑張ったこと" },
  { name: "scheduled_at", label: "イベント開催日時" },
  { name: "business_categories", label: "志望業界" },
  { name: "preferred_job_type_names", label: "志望職種" },
  { name: "preferred_work_prefecture_names", label: "志望勤務地" },
  { name: "company_choice_factor_names", label: "企業選びの軸" }
] as const;
